<div class="contract-details-view-container" *ngIf="contractBalanceObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayout.lt-lg="column" fxLayoutGap="15px">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Stan Salda</h3>
            </div>
            <div fxLayout="row"  fxLayoutGap="15px" fxLayoutAlign="center center">
              <app-detail fxFlex="33" header="Kwota do wypłacenia" [value]="">{{(contractBalanceObject.toPayNet === null ? 0 : contractBalanceObject.toPayNet) | number:'1.2-2'}} zł
              </app-detail>
              <app-detail fxFlex="33" header="Kwota zapłacona" [value]=""> {{(contractBalanceObject.paid === null ? 0 : contractBalanceObject.paid) | number:'1.2-2'}} zł
              </app-detail>
              <div fxFlex="33" fxLayoutAlign="center center">
                <button [disabled]="!(userPermissions | async).settlement.write"  (click)="addInitialBalance()" mat-stroked-button color="primary"> <mat-icon>add</mat-icon> <span>Dodaj saldo</span></button>
              </div>
            </div>
          </mat-card>
        </div>
      </div>
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <ng-container *ngIf="commissionContractSettlement.length">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Rozliczenia</h3>
            </div>

              <table mat-table [dataSource]="commissionContractSettlement" >
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef> Numer </th>
                  <td mat-cell *matCellDef="let element">
                    <a class="default-link" [routerLink]="['/rozliczenia/szczegoly', element?.commissionSettlement.uuid]">
                      {{element.commissionSettlement.number}}
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="billingMonth">
                  <th mat-header-cell *matHeaderCellDef> Miesiąc rozliczeniowy </th>
                  <td mat-cell *matCellDef="let element">
                    <a class="default-link" [routerLink]="['/rozliczenia/szczegoly', element?.commissionSettlement.uuid]">
                      {{element.commissionSettlement.billingMonth}} -
                      <ng-container *ngIf="element.commissionSettlement.partner">
                        {{element.commissionSettlement.partner?.shortName}}
                      </ng-container>

                      <ng-container *ngIf="element.commissionSettlement.ofwca">
                        {{element.commissionSettlement.ofwca.fullName}}
                      </ng-container>
                    </a>
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef> Status </th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-raised-button [ngClass]="element.commissionSettlement?.status.color + '-button'">
                      {{element.commissionSettlement.status.name}}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="totalCollection">
                  <th mat-header-cell *matHeaderCellDef> Suma inkaso </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.totalCollection | number:'1.2-2'}} zł
                  </td>
                </ng-container>

                <ng-container matColumnDef="totalCommission">
                  <th mat-header-cell *matHeaderCellDef> Suma prowizji </th>
                  <td mat-cell *matCellDef="let element">
                    {{(element.totalCommission === null ? 0 : element.totalCommission) | number:'1.2-2'}} zł
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsContractSettlement"></tr>
                <tr mat-row *matRowDef="let element; let row; columns: displayedColumnsContractSettlement;"></tr>
              </table>

          </mat-card>
          </ng-container>
        </div>
      </div>

      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <ng-container *ngIf="invoices.length">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Lista faktur</h3>
            </div>

              <table mat-table [dataSource]="invoices" multiTemplateDataRows>
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef>Numer faktury</th>
                  <td mat-cell *matCellDef="let element">
                    <div fxLayout="row" fxLayoutGap="5" fxLayoutAlign="start center" >
                      <a class="default-link" [routerLink]="['/faktury/szczegoly', element.id]">
                        {{element.number}}
                      </a>
                      <mat-chip-list *ngIf="element.selfBilling" >
                        <mat-chip class="statusChange-button-container" color="primary"  matTooltip="Samofakturowanie">S</mat-chip>
                      </mat-chip-list>
                    </div>
                  </td>
                </ng-container>
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Data wystawienia</th>
                  <td mat-cell *matCellDef="let element">
                    {{element.issueDate | date:'y-MM-dd'}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="net">
                  <th mat-header-cell *matHeaderCellDef>Kwota faktury</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.net === element.gross">
                      {{element.net | number:'1.2-2'}} zł
                      </ng-container>
                      <ng-container *ngIf="element.net !== element.gross">
                        {{element.net | number:'1.2-2'}} / {{element.gross | number:'1.2-2'}} zł
                      </ng-container>
                  </td>
                </ng-container>
                <ng-container matColumnDef="paymentDate">
                  <th mat-header-cell *matHeaderCellDef > Data wysłania do płatności </th>
                  <td mat-cell *matCellDef="let element">
                    {{element.paymentDate | date:'y-MM-dd'}}
                  </td>
                </ng-container>
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef>Status</th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-raised-button [ngClass]="element.status.color + '-button'">
                      {{element.status.name}}
                    </button>
                  </td>
                </ng-container>
                <ng-container matColumnDef="expandedDetail">
                  <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length" class="table-td expanded-row-td">
                    <ng-container *ngIf="element.noteDeductions.length">
                      <div class="invoice-documents">
                        <div class="table-grid mb-5">
                          <span class="primary">Numer noty</span>
                          <span class="primary">Data wystawienia</span>
                          <span class="primary">Kwota noty</span>
                        </div>
                        <div class="table-grid mb-5" *ngFor="let invoiceDocument of element.noteDeductions">
                          <span>{{invoiceDocument.invoiceDocument.number}} </span>
                          <span>{{invoiceDocument.invoiceDocument.issueDate | date:'y-MM-dd'}} </span>
                          <span>{{(invoiceDocument.invoiceDocument.net === null ? 0 : invoiceDocument.invoiceDocument.net) | number:'1.2-2'}} zł</span>
                        </div>
                      </div>
                    </ng-container>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let element; let row; columns: displayedColumns;"></tr>
                <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expanded-data-row"></tr>
                <!--                <tr mat-row *matRowDef="let row; columns: ['expandedDetailFv']" class="expanded-data-row"></tr>-->
              </table>

          </mat-card>
          </ng-container>
        </div>
      </div>
    </div>
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxLayout="row" fxFlex.lt-md="100%" >
        <div fxFlex="100">
          <mat-card class="partners-add-card">
            <div fxLayout="row">
              <h3>Dane salda</h3>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="contractBalanceObject.partner">
              <app-detail fxFlex="50" header="Strona umowy" value="Partner"></app-detail>

              <app-detail fxFlex="50" header="Partner" [value]="contractBalanceObject.partner?.shortName"
                          [link]="contractBalanceObject.partner ? ['/partnerzy/szczegoly', contractBalanceObject.partner?.uuid] : undefined"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px" *ngIf="contractBalanceObject.ofwca">
              <app-detail fxFlex="50" header="Strona umowy" value="OFWCA"></app-detail>

              <app-detail fxFlex="100" header="OFWCA" [value]="contractBalanceObject.ofwca?.fullName"
                          [link]="['/ofwca/szczegoly', contractBalanceObject.ofwca?.uuid]"></app-detail>
            </div>

            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Numer umowy" [value]="contractBalanceObject.contract?.number"
                            [link]="['/umowy/szczegoly', contractBalanceObject.contract?.uuid]">
                </app-detail>
              </div>
                <div fxFlex="50">
                <app-detail header="Status umowy" [value]="contractBalanceObject.contract?.status?.name"></app-detail>
              </div>
            </div>
            <div fxLayout="row" fxLayoutGap="15px">
              <div fxFlex="50">
                <app-detail header="Rodzaj umowy" [value]="contractBalanceObject?.contract.type?.name"></app-detail>
              </div>
              <div fxFlex="50">
                <app-detail header="Firma" [value]="contractBalanceObject?.contract.company?.name"></app-detail>
              </div>
            </div>

          </mat-card>

        </div>
      </div>
    </div>
  </div>

</div>
